import axios from "axios";
import lodash from "lodash";

const mergeCustomizer = (objValue, srcValue) => {
    if (lodash.isArray(objValue)) {
        return lodash.uniq(objValue.concat(srcValue));
    }
};

const setChildrenInfo = (data = []) => {
    let tmp = {
        children_auto_ids: [],
        children_types: [],
        children_status: [],
        children_type_object: {},
        children_status_object: {}
    };
    data.forEach(item => {
        let obj = {};
        if (item.children && item.children.length) {
            obj = setChildrenInfo(item.children);
        }
        lodash.forIn(obj, (value, key) => {
            item[key] = value;
        });

        tmp.children_auto_ids.push(item.server_info.server_auto_id);
        tmp.children_types.push(item.server_info.server_type);
        tmp.children_status.push(item.server_info.server_status);

        tmp.children_type_object[item.server_info.server_auto_id] =
            item.server_info.server_type;
        tmp.children_status_object[item.server_info.server_auto_id] =
            item.server_info.server_status;
        tmp = lodash.mergeWith({}, tmp, obj, mergeCustomizer);
    });
    return tmp;
};

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    serverList: [],
    regionList: {},
    currentRegion: "",
    demoStatus: false,
    servers: {},
    srcServers: {},
    regionTips: {}
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_SERVERS({ commit, rootState, dispatch }, args) {
        commit("PRIVATE_LOADING", true, { root: true });
        let data = "",
            servers = "";
        return rootState.$helper.request
            .get(rootState.$config.api.serverlist)
            .then(function(res) {
                data = res.data.server_rela;
                servers = res.data.servers;
                commit("_updateServerList", data);
                commit("_updateServers", servers);
                commit("_updateSrcServers", servers);
                commit("PRIVATE_LOADING", false, { root: true });
                return res;
            })
            .catch(function(err) {
                commit("PRIVATE_LOADING", false, { root: true });
                dispatch("ERROR_HANDLE", err, { root: true });
            });
    },
    GET_REGIONS({ commit, rootState, dispatch }, args) {
        rootState.$helper.request
            .get(rootState.$config.api.region)
            .then(function(res) {
                commit("_updateRegion", res.data.result);
            })
            .catch(function(err) {
                dispatch("ERROR_HANDLE", err, { root: true });
            });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {
    GET_DEMO_GETTER(state, getters) {
        let data = getters.getDemoGetterOthr;
        state.serverList = state.serverList.concat(data);
        return state.serverList;
    },

    getDemoGetterOthr(state, getters) {
        return [];
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _updateServerList(state, args) {
        let tmp = [];
        _.forEach(args, function(value, key) {
            tmp = tmp.concat(
                value.root_server.map(item => {
                    return Object.assign({ parent: true }, item);
                })
            );

            if (state.regionList[key]) {
                if (!state.currentRegion) state.currentRegion = key;
                state.regionTips[key] = [value.open_num, value.close_num];
            }
        });

        setChildrenInfo(tmp);
        state.serverList = tmp;
    },

    _updateServers(state, args) {
        state.servers = {};
        _.forEach(args, function(value, key) {
            if (value.merge_target == 0) {
                state.servers[key] = value;
            }
        });
    },

    _updateSrcServers(state, servers) {
        state.srcServers = servers;
    },

    _updateRegion(state, args) {
        state.regionList = {};
        _.forEach(args, function(value, key) {
            state.regionList[value.region_code] = value.region_name;
        });
    },

    /**
     * 对外的方法
     * @param state
     * @param args
     * @constructor
     */
    DEMO_MUTATIONS(state, args) {
        state.demoStatus = args;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/gameConfig/server.js